// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loading_loaderContainer__1jUxo","loader":"Loading_loader__2CqNh"};